export default [
  'MicroMessenger',
  'WeChat',
  'Weixin',
  'WeiXin',
  'WEIXIN',
  'WECHAT',
  'MICROMESSENGER',
]